import { categoriesWithIcons } from '@/mocks/radios';

interface CategoriesProps {
  onCategorySelect: (category: string) => void;
}

export default function Categories({ onCategorySelect }: CategoriesProps) {
  const handleCategoryClick = (e: React.MouseEvent, categoryName: string) => {
    e.preventDefault();
    onCategorySelect(categoryName);
    setTimeout(() => {
      const el = document.querySelector('#destacadas');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <section id="explorar" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            <i className="ri-compass-3-line text-xs"></i>
            Explorar por Categoría
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 tracking-tight">
            Encuentra tu <span className="text-primary-600">frecuencia ideal</span>
          </h2>
          <p className="mt-3 text-foreground-500 text-base max-w-xl mx-auto">
            Navega por nuestras categorías y descubre estaciones que se ajustan a lo que buscas.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categoriesWithIcons.map((cat) => (
            <a
              key={cat.name}
              href="#destacadas"
              onClick={(e) => handleCategoryClick(e, cat.name)}
              className="group bg-background-50 border border-background-200/80 hover:border-primary-300 hover:bg-primary-50/30 rounded-2xl p-5 md:p-6 flex flex-col items-center text-center gap-3 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-foreground-800 font-semibold text-sm md:text-base">{cat.name}</span>
              <span className="text-foreground-400 text-xs">
                {cat.name === 'Cristiana' ? '2 radios' :
                 cat.name === 'Regional Mexicana' ? '2 radios' :
                 cat.name === 'Pop' ? '2 radios' :
                 cat.name === 'Rock' ? '1 radio' :
                 cat.name === 'Noticias' ? '1 radio' :
                 cat.name === 'Deportes' ? '1 radio' :
                 cat.name === 'Comunitaria' ? '2 radios' : '1 radio'}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}